import React, { useEffect, useRef, useState } from 'react';
import './check-in-out-data.styles.scss';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { getCheckInOutDataFromDb, getEvalDataFromDb } from '../../../utils/getDataFromDb';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faCaretDown, faCaretUp, faDownload } from '@fortawesome/free-solid-svg-icons';
import SearchBar from '../../SHARED/search-bar/search-bar.component';
import CsvDownloadButton from 'react-json-to-csv'
import { format } from 'date-fns';
import { faFile } from '@fortawesome/free-regular-svg-icons';
import { obfuscateString } from '../../../utils/obfuscation';

const CheckInOutData = () => {

  const { evalId } = useParams();
  const [evaluationData, setEvaluationData] = useState({});
  const [dataToDisplay, setDataToDisplay] = useState(null);
  const [sortObj, setSortObj] = useState({
    'ts': true,
    'lName': true,
    'email': true,
    'school': true,
    'dist': true
  }); // false = desc, true = asc
  const [downloadableList, setDownloadableList] = useState(null);
  const checkInOutRef = useRef();
  const navigate = useNavigate();
  let checkInOutListener;

  useEffect(() => {

    return () => {
      if (checkInOutListener) checkInOutListener();
    };
  }, []);

  useEffect(() => {
    getEvalData();
  }, [evalId]);

  function getEvalData() {
    getEvalDataFromDb({
      'evalId': evalId,
      'once': true,
      'callback': callback
    });

    function callback(data) {
      setEvaluationData(data[evalId]);
      getCheckInOutData(data[evalId]);
    }
  }

  function getCheckInOutData(evalData) {
    getCheckInOutDataFromDb({
      'evalId': evalData.id,
      'callback': callback,
      'handleListener': handleListener
    });

    function callback(data) {
      console.log(data);
      checkInOutRef.current = {
        ...checkInOutRef.current,
        ...{ [data.id]: data }
      }
      const sortedData =  Object.values(checkInOutRef.current)
          .sort((a, b) => b.ts - a.ts);
      setDataToDisplay(sortedData);
      const downloadableList = setupCsvDownload(sortedData);
      setDownloadableList(downloadableList);
    }
    function handleListener(unsub) {
      checkInOutListener = unsub;
    }
  }

  function sortResults(e) {
    let searchText;
    const searchInput = document.getElementById('check-in-out-search');
    if (searchInput) {
      searchText = searchInput.value.toLowerCase().trim();
    }

    const sortedAndFilteredData = Object.values(checkInOutRef.current)
        .filter(d => {
          if (!searchText) return true;
          if (d.fName.toLowerCase().includes(searchText)) return true;
          if (d.lName.toLowerCase().includes(searchText)) return true;
          if (d.email.toLowerCase().includes(searchText)) return true;
          if (d.school.toLowerCase().includes(searchText)) return true;
          if (d.dist.toLowerCase().includes(searchText)) return true;
          return false;
        })
        .sort((a, b) => {
          if (sortObj[e]) {
            return b[e] > a[e] ? 1 : -1;
          } else {
            return a[e] > b[e] ? 1 : -1;
          }
        })
    setDataToDisplay(sortedAndFilteredData);
    const downloadableList = setupCsvDownload(sortedAndFilteredData);
    setDownloadableList(downloadableList);
    let currentObj = { ...sortObj };
    for (let k of Object.keys(currentObj)) {
      if (k !== e) {
        currentObj[k] = true;
      } else {
        currentObj[k] = !sortObj[k];
      }
    }
    setSortObj(currentObj);
  }

  function setupCsvDownload(arr) {
    // console.log(arr);
    if (!arr[0]) { return null }
    const keyArr = Object.keys(arr[0]).sort()
    let keys = []
    keys.push(
      'date', 
      'fName', 
      'lName', 
      'email', 
      'iein',
      'school', 
      'dist', 
      'cst_key', 
      'evalName', 
      'evalId', 
      'evalItemId', 
      'evalSource', 
      'ts'
    ) 
    for (let k of keyArr) {
      if (!keys.includes(k)) {
        keys.push(k)
      }
    }
    let newArr = [keys]
    for (let a of arr) {
      let row = []
      for (let key of keys) {
        let value = a[key]
        if (key === 'date') {
          value = new Date(a.ts).toLocaleString();
        }
        if (key === 'evalName') {
          value = evaluationData?.item?.title || '';
        }
        row.push(value)
      }

      newArr.push(row)
    }
    return newArr
  }


  return (
    <div className='check-in-out-data-container'>
      <div className='check-in-out-data-content g-card'>
        <button
          className='g-button small-btn'
          onClick={() => navigate(-1)}>
          <FontAwesomeIcon icon={faArrowLeft} />
          Back
        </button>
        <div className="g-space-1"></div>
        <div className='eval-data-header'>
          <h3>{evaluationData?.item?.title}</h3>
        </div>
        <hr />
        {
          (dataToDisplay && dataToDisplay.length > 0) 
          ?
          <div className='data-container'>
            <div className='data-header'>
              <div className='title'>Check In/Out Data</div>
              <div className='meta'>Entries: {dataToDisplay.length}</div>
              {/* <button className='g-button small-btn'>
                <FontAwesomeIcon icon={faDownload} />
                Download CSV
              </button> */}
              <CsvDownloadButton
                data={downloadableList}
                delimiter=','
                filename={`checkinout-${evaluationData?.item?.title}-${format(new Date(), 'Pp').replace(/0-9a-zA-Z]/g, '')}.csv`}
                className={`g-button small-btn ${downloadableList.length > 0 ? '' : 'disabled'}`}>
                <FontAwesomeIcon icon={faDownload} />Download this list
              </CsvDownloadButton>
            </div>
            <div className="g-space-1"></div>
            <SearchBar search={sortResults} idLabel="check-in-out-search" />
            <table className='uk-table uk-table-striped'>
              <thead>
                <tr>
                  <th
                    onClick={() => sortResults('lName')}>
                    <button className='g-button text-only sortable'>
                      Name
                      <FontAwesomeIcon
                        icon={sortObj.lName ? faCaretDown : faCaretUp} />
                    </button>
                  </th>
                  <th
                    onClick={() => {
                      sortResults('email');
                    }}>
                    <button className='g-button text-only sortable'>
                      Email
                      <FontAwesomeIcon
                        icon={sortObj.email ? faCaretDown : faCaretUp} />
                    </button>
                  </th>
                  <th
                    onClick={() => {
                      sortResults('iein');
                    }}>
                    <button className='g-button text-only sortable'>
                      IEIN
                      <FontAwesomeIcon
                        icon={sortObj.iein ? faCaretDown : faCaretUp} />
                    </button>
                  </th>
                  <th
                    onClick={() => {
                      sortResults('school');
                    }}>
                    <button className='g-button text-only sortable'>
                      School
                      <FontAwesomeIcon icon={sortObj.school ? faCaretDown : faCaretUp} />
                    </button>
                  </th>
                  <th
                    onClick={() => {
                      sortResults('dist');
                    }}>
                    <button className='g-button text-only sortable'>
                      District
                      <FontAwesomeIcon icon={sortObj.dist ? faCaretDown : faCaretUp} />
                    </button>
                  </th>
                  <th
                    onClick={() => {
                      sortResults('ts');
                    }}>
                    <button className='g-button text-only sortable'>
                      Timestamp
                      <FontAwesomeIcon icon={sortObj.ts ? faCaretDown : faCaretUp} />
                    </button>
                  </th>
                  {
                    (evaluationData.cpdu) &&
                    <th width="50px">
                      <div className='buttons'>
                        
                      </div>
                    </th>
                  }
                </tr>
              </thead>
              <tbody>
                {
                  (dataToDisplay.length > 0)
                    ?
                    dataToDisplay
                      .map(d => {
                        const urlString = obfuscateString(JSON.stringify({ 'evalId': d.evalId, 'cstKey': d.cst_key }));
                        return (
                          <tr key={d.id}>
                            <td>{d.lName}, {d.fName}</td>
                            <td>{d.email}</td>
                            <td>{d.iein}</td>
                            <td>{d.school}</td>
                            <td>{d.dist}</td>
                            <td>{new Date(d.ts).toLocaleString()}</td>
                            {
                              (evaluationData.cpdu) &&
                              <td>
                                <div className='buttons'>
                                  <Link to={`/print/${urlString}`} target="_blank">
                                    <button className='g-button med-btn' >
                                      <FontAwesomeIcon
                                        icon={faFile} />
                                    </button>
                                  </Link>
                                </div>
                              </td>
                            }
                          </tr>
                        )
                      })
                    :
                    <tr><td colSpan={4}>No Check In/Out Data Recorded...</td></tr>
                }
              </tbody>
            </table>
          </div>
          :
          <p>No check in/out data has been recorded yet.</p>
        }
      </div>
    </div>
  )
}

export default CheckInOutData